import { LegalEntityMatchResult } from '../../../models/bill-import.models';
import { SaEditData } from '../state/bill-ai-flow.models';
import {
  FieldError,
  StepValidationResult,
  ValidationRule,
  getByPath,
  isEmpty,
} from '../validation';

/** Rules for the SA step — only apply when creating a new SA */
const ONLY_IF_NEW = (ctx: { isNew: boolean }) => ctx.isNew;

export const SA_RULES: ValidationRule[] = [
  { field: 'street1', label: 'Street 1', severity: 'required', condition: ONLY_IF_NEW },
  { field: 'city',    label: 'City',     severity: 'required', condition: ONLY_IF_NEW },
  { field: 'state',   label: 'State',    severity: 'required', condition: ONLY_IF_NEW },
  { field: 'zip',     label: 'ZIP',      severity: 'required', condition: ONLY_IF_NEW },
];

export interface SaValidationInput {
  legalEntities: LegalEntityMatchResult[];
  saEdits: Record<string, SaEditData>;
  isNewEntity: (groupId: string) => boolean;
}

function describeSa(saGroupId: string, edit: SaEditData | undefined): string {
  const parts = [edit?.street1, edit?.city, edit?.state].filter(Boolean);
  if (parts.length > 0) return parts.join(', ');
  return `Service Address ${saGroupId.slice(0, 8)}`;
}

export function validateSaStep(input: SaValidationInput): StepValidationResult {
  const errors: FieldError[] = [];
  const warnings: FieldError[] = [];

  for (const len of input.legalEntities) {
    for (const sa of len.serviceAddresses) {
      const edit = input.saEdits[sa.groupId] ?? {};
      const entityLabel = describeSa(sa.groupId, edit);
      const isNew = input.isNewEntity(sa.groupId);

      for (const rule of SA_RULES) {
        if (rule.condition && !rule.condition({ entity: edit, isNew })) continue;
        const value = getByPath(edit, rule.field);
        if (isEmpty(value)) {
          const err: FieldError = {
            entityId: sa.groupId,
            entityLabel,
            field: rule.field,
            label: rule.label,
            severity: rule.severity,
          };
          if (rule.severity === 'required') errors.push(err);
          else warnings.push(err);
        }
      }
    }
  }

  return { errors, warnings, hasBlockers: errors.length > 0 };
}
